import * as React from 'react';
export const SvgGroupUngroup = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', ...props },
        React.createElement("g", { fillRule: 'evenodd', fill: 'var(--iui-color-icon-muted, currentColor)' },
            React.createElement("path", { d: 'M12 8a4 4 0 11-4 4 4 4 0 014-4', opacity: 0.5 }),
            React.createElement("path", { d: 'M4 0L0 8h8' }))));
};
export default SvgGroupUngroup;
